module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://dashboard-api.nextday.media/"}};